<template>
    <div class="style-form py-4 p-lg-5">
        <div class="col-12 pb-5">
            <h5 class="font-weight-bold">Envianos un mensaje</h5>
        </div>
        <div class="col-12">
            <form
                id="form-real-state"
                class="row"
                @submit.prevent="sendMessage"
                @recaptcha-success="captchaCompleted = true"
                @recaptcha-invalid="captchaCompleted = false"
                method="POST"
            >
                <input type="hidden" name="_token" :value="csrf" />
                <div class="col-12 col-md-6 form-group">
                    <input
                        type="text"
                        placeholder="Nombre de la empresa"
                        v-model.trim="$v.form.empresa.$model"
                        name="empresa"
                        :class="
                            !$v.form.empresa.$anyError
                                ? 'form-control w-100'
                                : 'form-control w-100 form-error'
                        "
                    />
                    <div class="error-data" v-if="$v.form.empresa.$dirty">
                        <span v-if="!$v.form.empresa.required"
                            >Campo necesario</span
                        >
                    </div>
                </div>
                <div class="col-12 col-md-6 form-group">
                    <input
                        type="text"
                        placeholder="Cargo"
                        v-model.trim="$v.form.cargo.$model"
                        name="cargo"
                        :class="
                            !$v.form.cargo.$anyError
                                ? 'form-control w-100'
                                : 'form-control w-100 form-error'
                        "
                    />
                    <div class="error-data" v-if="$v.form.cargo.$dirty">
                        <span v-if="!$v.form.cargo.required"
                            >Campo necesario</span
                        >
                    </div>
                </div>
                <div class="col-12 col-md-6 form-group">
                    <input
                        type="text"
                        placeholder="Nombre"
                        v-model.trim="$v.form.nombre.$model"
                        name="nombre"
                        :class="
                            !$v.form.nombre.$anyError
                                ? 'form-control w-100'
                                : 'form-control w-100 form-error'
                        "
                    />
                    <div class="error-data" v-if="$v.form.nombre.$dirty">
                        <span v-if="!$v.form.nombre.required"
                            >Campo necesario</span
                        >
                    </div>
                </div>
                <div class="col-12 col-md-6 form-group">
                    <input
                        type="text"
                        placeholder="Apellido"
                        v-model.trim="$v.form.apellido.$model"
                        name="apellido"
                        :class="
                            !$v.form.apellido.$anyError
                                ? 'form-control w-100'
                                : 'form-control w-100 form-error'
                        "
                    />
                    <div class="error-data" v-if="$v.form.apellido.$dirty">
                        <span v-if="!$v.form.apellido.required"
                            >Campo necesario</span
                        >
                    </div>
                </div>
                <div class="col-12 col-md-6 form-group">
                    <input
                        type="text"
                        placeholder="Email"
                        v-model.trim="$v.form.email.$model"
                        name="email"
                        :class="
                            !$v.form.email.$anyError
                                ? 'form-control w-100'
                                : 'form-control w-100 form-error'
                        "
                    />
                    <div class="error-data" v-if="$v.form.email.$dirty">
                        <span v-if="!$v.form.email.required"
                            >Campo necesario</span
                        >
                        <span v-if="!$v.form.email.email">Email inválido</span>
                    </div>
                </div>
                <div class="col-12 col-md-6 form-group">
                    <input
                        type="text"
                        placeholder="Teléfono"
                        @keypress="onlyNumber"
                        v-model.trim="$v.form.telefono.$model"
                        maxlength="9"
                        name="telefono"
                        :class="
                            !$v.form.telefono.$anyError
                                ? 'form-control w-100'
                                : 'form-control w-100 form-error'
                        "
                    />
                    <div class="error-data" v-if="$v.form.telefono.$dirty">
                        <span v-if="!$v.form.telefono.required"
                            >Campo necesario</span
                        >
                        <span v-if="!$v.form.telefono.minLength"
                            >Teléfono inválido</span
                        >
                        <span v-if="!$v.form.telefono.maxLength"
                            >Teléfono inválido</span
                        >
                    </div>
                </div>
                <div class="col-12 form-group">
                    <textarea
                        cols="30"
                        rows="6"
                        placeholder="Mensaje"
                        v-model.trim="$v.form.mensaje.$model"
                        name="mensaje"
                        :class="
                            !$v.form.mensaje.$anyError
                                ? 'form-control w-100'
                                : 'form-control w-100 form-error'
                        "
                    >
                    </textarea>
                    <div class="error-data" v-if="$v.form.mensaje.$dirty">
                        <span v-if="!$v.form.mensaje.required"
                            >Campo necesario</span
                        >
                    </div>
                </div>
                <div class="col-12 d-flex justify-content-end" id="g-recaptcha" name="g-recaptcha"></div>
                <div class="col-12 col-md-5 ml-auto mt-3">
                    <button
                        :disabled="formLoading || $v.form.$invalid || !captchaCompleted"
                        type="submit"
                        class="btn bg-main-color text-white btn-block"
                    >
                        {{ btnText }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { required, minLength, email, maxLength } from 'vuelidate/lib/validators'

export default {
    name: 'inmobiliaria',
    data: () => ({
        csrf: document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute('content'),
        captchaCompleted: false,
        formLoading: false,
        btnText: 'Enviar',
        form: {
            empresa: '',
            cargo: '',
            nombre: '',
            apellido: '',
            email: '',
            telefono: '',
            mensaje: ''
        }
    }),
    methods: {
        sendMessage () {
            this.$v.form.$touch()
            if (!this.$v.form.$invalid) {
                if (!window.grecaptcha || window.grecaptcha.getResponse() === '') {
                    return
                }

                this.btnText = 'Enviando...'
                this.formLoading = true
                const ruta = `/contacto-empresa`
                $('#form-real-state').attr('action', ruta).submit()
            }
        },
        onlyNumber ($event) {
            let keyCode = $event.keyCode ? $event.keyCode : $event.which
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
                // 46 is dot
                $event.preventDefault()
            }
        }
    },
    validations: {
        form: {
            empresa: {
                required
            },
            cargo: {
                required
            },
            nombre: {
                required
            },
            apellido: {
                required
            },
            email: {
                required,
                email
            },
            telefono: {
                required,
                minLength: minLength(9),
                maxLength: maxLength(9)
            },
            mensaje: {
                required
            }
        }
    }
}
</script>

<style scoped>
.style-form {
    background-color: #fff;
}

.icon-style {
    font-size: 3rem !important;
}

.color-text-default {
    color: #707070;
}
</style>
